<p-tree
  class="w-full md:w-30rem"
  filterPlaceholder="durchsuchen ..."
  selectionMode="single"
  (selectionChange)="selectionChange($event)"
  [filter]="true"
  [value]="categoryStore.asTree()">
</p-tree>
